import React, { useMemo } from 'react';
import { useNavigation } from '../function/navigation';
import { useNotification } from '../components/NotificationContext';
import '../css/ProgressBar.css';

const STEP_PAYLOAD = {
  project: 'projectManager',
  pdc: 'pdcPage',
  configuration: 'machine',
  product: 'product',
};

function getCurrentIndex(mainPage, stepsId) {
  if (!mainPage) return 0;

  const byPayload = stepsId.findIndex((id) => STEP_PAYLOAD[id] === mainPage);
  if (byPayload !== -1) return byPayload;

  const byId = stepsId.indexOf(mainPage);
  if (byId !== -1) return byId;

  return 0;
}

export default function ProgressBar({ setLaunchId }) {
  const { nav, dispatch } = useNavigation();
  const { showNotification, hideNotification } = useNotification();
  const currentMainPage = nav?.mainPage;

  const stepsId =
    currentMainPage === 'product'
      ? ['project', 'pdc', 'configuration', 'product']
      : ['project', 'pdc', 'configuration'];
  const currentIndex = useMemo(
    () => getCurrentIndex(currentMainPage, stepsId),
    [currentMainPage]
  );

  const confirmResetAndGoToProject = () => {
    showNotification({
      type: 'warning',
      title: 'Reset Configuration?',
      message: [
        'You will lose your configuration if you go back to project.',
        'Are you sure you want to continue?',
      ],
      extraButtons: [
        {
          label: 'Yes',
          type: 'confirm',
          action: () => {
            setLaunchId(null);
            hideNotification();
          },
        },
        {
          label: 'Cancel',
          type: 'cancel',
          action: () => hideNotification(),
        },
      ],
    });
  };

  return (
    <nav className="progressbar-container" aria-label="Progress">
      {stepsId.map((id, index) => {
        const isCurrent = index === currentIndex;
        const isPast = index < currentIndex;
        const isFuture = index > currentIndex;

        const payload = STEP_PAYLOAD[id];
        const isClickable = isPast && payload;

        const handleClick = () => {
          if (!isClickable) return;
          if (id === 'project') {
            confirmResetAndGoToProject();
            return;
          }
          dispatch({ type: 'mainPage', payload });
        };

        return (
          <React.Fragment key={id}>
            <div
              type="button"
              onClick={handleClick}
              disabled={!isClickable}
              className={`progressbar-step 
                ${isCurrent ? 'current' : ''}
                ${isFuture ? 'future' : ''}`}
            >
              {id}
            </div>

            {index < stepsId.length - 1 && (
              <span className="progressbar-separator">{'>'}</span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
